import React from 'react';
import { Search, Filter, Calendar } from 'lucide-react';
import SearchableSelect from '@/client/components/admin/SearchableSelect';

interface ServiceRequestListFiltersProps {
  onSearch: (query: string) => void;
  searchValue?: string;
  onFilterChange: (key: string, value: string) => void;
  filters: {
    status: string;
    type: string;
    organization: string;
    period: string;
  };
}

const ServiceRequestListFilters: React.FC<ServiceRequestListFiltersProps> = ({
  onSearch,
  searchValue,
  onFilterChange,
  filters
}) => {
  return (
    <div className="bg-white p-4 rounded-lg mb-6 border border-gray-200">
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
        <div className="flex items-center gap-4 w-full md:w-auto flex-wrap">
          {/* Search Input */}
          <div className="relative w-full md:w-64">
            <input
              type="text"
              value={searchValue}
              placeholder="Search requests..."
              className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              onChange={(e) => onSearch(e.target.value)}
            />
            <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
          </div>

          <SearchableSelect
            options={[
              { value: '', label: 'All Status' },
              { value: 'active', label: 'Active' },
              { value: 'paused', label: 'Paused' },
              { value: 'scheduled', label: 'Scheduled' },
              { value: 'draft', label: 'Draft' },
              { value: 'expired', label: 'Expired' },
              { value: 'canceled', label: 'Canceled' },
              { value: 'inactive', label: 'Inactive' },
            ]}
            value={filters.status}
            onChange={(value) => onFilterChange('status', value)}
            placeholder="Status"
            icon={Filter}
            className="w-full md:w-48"
          />

          <SearchableSelect
            options={[
              { value: '', label: 'All Types' },
              { value: 'featured', label: 'Featured' },
              { value: 'spotlight', label: 'Spotlight' },
              { value: 'premium', label: 'Premium' }
            ]}
            value={filters.type}
            onChange={(value) => onFilterChange('type', value)}
            placeholder="Type"
            icon={Filter}
            className="w-full md:w-48"
          />

          <SearchableSelect
            options={[
              { value: 'last7days', label: 'Last 7 Days' },
              { value: 'last30days', label: 'Last 30 Days' },
              { value: 'last3months', label: 'Last 3 Months' },
              { value: 'last6months', label: 'Last 6 Months' }
            ]}
            value={filters.period}
            onChange={(value) => onFilterChange('period', value)}
            placeholder="Time Period"
            icon={Calendar}
            className="w-full md:w-48"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceRequestListFilters;
